import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class CurrentUser extends ApplicationRecord {
  static jsonapiType = "current_user";

  @Attr() companyId: string;

  @Attr() isRecruiter: boolean;

  @Attr() isEmployer: boolean;

  @Attr() isPortalUser: boolean;

  @Attr() isPartnerUser: boolean;

  @Attr() isRootParentEmployer: boolean;
}

export default CurrentUser;
